import * as types from '../actionsTypes/strumentiActionsType'

import { notifsActions,loadingOverlayActions } from '../index';
import new_axios_instance from '../../axios_instance';
import {printOnlyInDevelopment} from "../../fanctionUtility";

//Recupero data ed ora dal server
export const getDataOra = () => async dispatch => {
        dispatch(loadingOverlayActions.showLoadingOverlay());

        await new_axios_instance.get("/v1/strumenti/recuperaDataeOra")
            .then( response => {
            printOnlyInDevelopment('Data ed ora server ::', response.data);
                dispatch({type: types.GET_DATA_ORA, payload: response.data});
                dispatch(loadingOverlayActions.hideLoadingOverlay());
        }).catch(e => {
            printOnlyInDevelopment('Data ed ora server ::', e);
                dispatch(loadingOverlayActions.hideLoadingOverlay());
                dispatch(notifsActions.notifError(e));
        });
};


